import "@fontsource/noto-sans-jp";
import "./src/styles/base.css";
import "./src/styles/blog-contents-style.css";

let vantaInstance = null;

/* -----------------------------
 * script ローダー
 * ---------------------------- */
const loadScript = (src) =>
  new Promise((resolve) => {
    const s = document.createElement("script");
    s.src = src;
    s.defer = true;
    s.onload = resolve;
    document.body.appendChild(s);
  });

/* -----------------------------
 * クライアント初期化
 * ---------------------------- */
export const onClientEntry = async () => {
  if (typeof document === "undefined") return;

  document.documentElement.classList.add("js");

  /* --- ▼ Vanta 読み込みを一時停止中 ▼ --- */
  /*
  // クローラー判定
  const isBot = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
  if (isBot) return;

  if (!window.__VANTA_LOADED__) {
    await loadScript(
      "https://cdnjs.cloudflare.com/ajax/libs/three.js/r121/three.min.js"
    );
    await loadScript(
      "https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.waves.min.js"
    );
    window.__VANTA_LOADED__ = true;
  }
  */
  /* --- ▲ Vanta 読み込みを一時停止中 ▲ --- */
};

/* -----------------------------
 * ルート更新時処理
 * ---------------------------- */
export const onRouteUpdate = () => {
  if (typeof document === "undefined") return;

  /* ===== fadeInUp（既存処理） ===== */
  const elements = document.querySelectorAll(".fadeInUp");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("on");
        }
      });
    },
    { threshold: 0.1 }
  );
  elements.forEach((el) => observer.observe(el));

  /* --- ▼ Vanta 初期化を一時停止中 ▼ --- */
  /*
  // クローラー判定（ビルドエラー回避のため typeof window チェックを入れた安全版）
  const isBot = typeof window !== "undefined" && window.navigator && /bot|googlebot|crawler|spider|robot|crawling/i.test(window.navigator.userAgent);
  if (isBot) return;

  if (!window.VANTA || !window.VANTA.WAVES || vantaInstance) return;

  requestAnimationFrame(() => {
    setTimeout(() => {
      const el = document.querySelector("#vanta-birds");
      if (!el) return;

      vantaInstance = window.VANTA.WAVES({
        el,
        color: 0x445c66,
        shininess: 50,
        waveHeight: 20,
        waveSpeed: 1.0,
        zoom: 1.0,
      });
    }, 50);
  });
  */
  /* --- ▲ Vanta 初期化を一時停止中 ▲ --- */
};